import React, { act } from "react";
import { Image, Button, Breadcrumb } from "react-bootstrap";
import searchIcon from "../../assets/images/material-symbols_search.svg";
import closeIcon from "../../assets/images/close.png";
import leftBackArrow from "../../assets/images/left-back-arrow.png";
import BaseReactComponent from "../../utils/form/BaseReactComponent";
import Form from "../../utils/form/Form";
import FormElement from "../../utils/form/FormElement";
import CustomTextControl from "../../utils/form/CustomTextControl";
import Spinner from "./Spinner";
import { withRouter } from "../../utils/hoc/withRouter";
import { Link } from "react-router-dom";
import Filters from "../../utils/commonComponent/CustomFIlterTab";

export class ComponentHeader extends BaseReactComponent {
  constructor(props) {
    super(props);
    this.state = {
      search: (props.searchValue && props.searchValue.search) || "",
      showFilter: props.showFilter || false, // Initialize with prop or false
    };
  }

  static defaultProps = {

    resLoading: false
  }

  delayTimer;

  onChangeMethod = (value) => {
    clearTimeout(this.delayTimer);
    this.delayTimer = setTimeout(() => {
      const { onChangeMethod, history, location } = this.props;
      const { search } = this.state;

      if (onChangeMethod) {
        onChangeMethod(this.state);
      } else {
        const params = new URLSearchParams(location.search);
        if (search) {
          params.set("search", search);
        } else {
          params.delete("search");
        }
        history({ search: params.toString() }, { replace: true });
      }
    }, 1000);
  };

  clearSearchValue = () => {
    const { clearSearch, history, location } = this.props;
    this.setState({ search: "" });

    if (clearSearch) {
      clearSearch();
    } else {
      const params = new URLSearchParams(location.search);
      params.delete("search");
      history({ search: params.toString() }, { replace: true });
    }
  };

  // Toggle filter visibility
  toggleFilter = () => {
    this.setState(prevState => ({
      showFilter: !prevState.showFilter
    }));
  };

  // Handle filter close
  handleFilterClose = () => {
    this.setState({ showFilter: false });
  };
  componentDidUpdate(prevProps) {
    const { filterOptions = [], ctx } = this.props;
    const currentVerification = ctx?.state.access?.verificationAccess;

    const filterOptionsChanged =
      JSON.stringify(prevProps.filterOptions) !== JSON.stringify(filterOptions);

    if (!filterOptionsChanged) return;

    let updatedOptions = [...filterOptions];

    if (currentVerification) {
      const verificationFilter = {
        label: "Verification Status",
        field: "isVerified",
        type: "single",
        options: [
          { label: "Verified", value: "1" },
          { label: "Unverified", value: "0" },
        ],
      };

      const alreadyAdded = updatedOptions.some(opt => opt.field === "isVerified");
      if (!alreadyAdded) {

        updatedOptions = [verificationFilter, ...updatedOptions];
      }
    }

    if (JSON.stringify(this.state.filterOptions) !== JSON.stringify(updatedOptions)) {
      this.setState({ filterOptions: updatedOptions });
    }
  }



  render() {
    const {
      title = "",
      handlePrimaryBtn,
      primaryBtn = "",
      isReturn = null,
      isBackArrow = false,
      isBack = null,
      isSearch = true,
      placeholder,
      onClose,
      breadcrumb = [],
    } = this.props;

    const filterOptions = this.state.filterOptions || [];

    const activeFilters = filterOptions.filter(filter => {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(filter.field);
    });
    return (
      <>
        {/* Show Filters only when showFilter is true AND filterOptions exist */}
        {filterOptions && filterOptions?.length > 0 && (
          <Filters
            filterOptions={filterOptions}
            show={this.state.showFilter} // Use state to control visibility
            handleClose={this.handleFilterClose}
          />
        )}

        <div className="section-sub-header">
          <div className="heading">
            {!breadcrumb.length && (
              <h3 className="inter-semibold f-s-20 lh-29">
                {isBackArrow && isReturn && (
                  <Image
                    onClick={() => isReturn === "back" ? this.props.history(-1) : this.props.history(isReturn)}
                    src={leftBackArrow}
                    alt="icon"
                    className="pointer"
                  />
                )}
                {isBackArrow && isBack && (
                  <Image
                    onClick={() => this.props.history(-1)}
                    src={leftBackArrow}
                    alt="icon"
                    className="pointer"
                  />
                )}
                {isBackArrow && onClose && (
                  <Image
                    onClick={() => this.props.onClose()}
                    src={leftBackArrow}
                    alt="icon"
                    className="pointer"
                  />
                )}
                {title}
              </h3>
            )}

            {breadcrumb.length > 0 && (
              <Breadcrumb seperator=">">
                {breadcrumb.map((bc, index) => (
                  <Breadcrumb.Item
                    active={index === breadcrumb.length - 1}
                    key={index}
                    linkAs={Link}
                    linkProps={{ to: bc[1] }}
                  >
                    {bc[0]}
                  </Breadcrumb.Item>
                ))}
              </Breadcrumb>
            )}
          </div>

          <div className="input-btn-wrapper">
            <div className="search">
              {isSearch && !this.props.isReturn && (title !== "Back") && (
                <Form onValidSubmit={this.onChangeMethod}>
                  <FormElement
                    valueLink={this.linkState(this, "search", this.onChangeMethod)}
                    control={{
                      type: CustomTextControl,
                      settings: {
                        placeholder: placeholder || "Search " + title,
                      },
                    }}
                    classes={{
                      inputField: "search-input",
                      prefix: "search-prefix",
                      suffix: "search-suffix",
                    }}
                  />
                  {this.state.search ? (
                    <Image
                      src={closeIcon}
                      onClick={this.clearSearchValue}
                      className="search-icon clear-icon"
                    />
                  ) : (
                    <Image src={searchIcon} className="search-icon" />
                  )}
                </Form>
              )}
            </div>
              <div className="actions d-flex align-items-center gap-12">
            {/* Filter button - now properly toggles visibility */}
            {filterOptions && filterOptions?.length > 0 && (
              <Button
                className={`secondary-btn d-flex ${this.state.showFilter ? 'active' : ''}`}
                onClick={this.toggleFilter}
              >
                <div className="filter-icon me-2">
                  {activeFilters.length > 0 ? (
                    <div className="dot-indicator"></div>)
                    : null}
                  {filterIcon}
                </div>
                Filter
              </Button>
            )}

            {primaryBtn && (
              this.props?.resLoading ? (
                <Button
                  onClick={() => { }}
                  className="primary-btn inter-medium f-s-12 lh-15 disable-download-btn"
                >
                  <Spinner />
                  Saving...
                </Button>
              ) : (
                <Button
                  onClick={handlePrimaryBtn}
                  className="primary-btn inter-medium f-s-12 lh-15"
                >
                  {primaryBtn}
                </Button>
              )
            )}
          </div>
          </div>
        </div>
        <hr className="mt-0 mb-5" />
      </>
    );
  }
}

export default withRouter(ComponentHeader);

export const filterIcon = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8.85697 12.5061C6.36852 10.6456 4.59515 8.59918 3.62685 7.4487C3.32711 7.09256 3.22889 6.83193 3.16984 6.37283C2.96763 4.80083 2.86652 4.01483 3.32747 3.50743C3.78841 3.00003 4.60355 3.00003 6.23384 3.00003H17.7652C19.3955 3.00003 20.2106 3.00003 20.6716 3.50743C21.1325 4.01483 21.0314 4.80083 20.8292 6.37284C20.7701 6.83194 20.6719 7.09257 20.3721 7.4487C19.4025 8.60065 17.6256 10.6507 15.1321 12.5136C14.9065 12.6821 14.7578 12.9568 14.7302 13.2614C14.4832 15.992 14.2554 17.4876 14.1136 18.2442C13.8848 19.4657 12.1527 20.2006 11.2255 20.8564C10.6736 21.2467 10.0038 20.782 9.93229 20.1778C9.79594 19.0261 9.53912 16.6864 9.25879 13.2614C9.2336 12.954 9.08437 12.6761 8.85697 12.5061Z" stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
</svg>
